export const config = {
  /** API サーバーの URL（ブラウザからアクセス） */
  apiUrl: "https://api.local.b-faq.run:3000",
  /** GTM コンテナ ID（開発環境では無効） */
  gtmContainerId: null,
  planCodes: {
    free: "free",
    beginner: "beginner",
    enterprise: "enterprise",
  },
  bypassPlanGate: false,
} as const;
